import React from "react";
import { useTableResponsive } from "../../../hooks/useTableResponsive";

const BondsTabs = ({ data }) => {
  useTableResponsive(data);
  return (
    <div className="container wow zoomIn">
      <div className="title-sec">
        <h2>{data.title}</h2>
      </div>
      <div dangerouslySetInnerHTML={{ __html: data.body }}></div>
    </div>
  );
};

export default BondsTabs;
